// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ie_J9","container__title":"styles_container__title__adyu7","skeleton-animation":"styles_skeleton-animation__NmScZ"};